export const fontWeights = {
  LIGHT_FONT_WEIGHT: 300,
  REGULAR_FONT_WEIGHT: 400,
  MEDIUM_FONT_WEIGHT: 500,
  SEMI_BOLD_FONT_WEIGHT: 600,
  BOLD_FONT_WEIGHT: 700,
};
